import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import HistorychangeService from "services/common/HistoryChangeService";

export const GetHistory = createAsyncThunk(
  "historyChange/GetHistory",
  async (data, { rejectWithValue }) => {
    try {
      const { objectId } = data;
      const response = await HistorychangeService.GetHistorychange(objectId);
      return response.data.data;
    } catch (err) {
      console.error("API call failed:", err);
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const GetHistorychangeOther = createAsyncThunk(
  "historyChange/GetHistorychangeOther",
  async (data, { rejectWithValue }) => {
    try {
      const { objectId ,onSuccess} = data;
      const response = await HistorychangeService.GetHistorychangeOther(
        objectId
      );
      if(onSuccess)onSuccess(response.data.data)
      return response.data.data;
    } catch (err) {
      console.error("API call failed:", err);
      return rejectWithValue(err.message || "Error");
    }
  }
);

const initialState = {
  loading: false,
  history: [],
  historyother: [],
};

const historyChange = createSlice({
  name: "historyChange",
  initialState,
  reducers: {
    resetHistoryChange: (state) => {
      state.history = [];
      state.historyother = [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(GetHistorychangeOther.pending, (state) => {
        state.loading = true;
      })
      .addCase(GetHistorychangeOther.fulfilled, (state, action) => {
        state.loading = false;
        state.historyother = action.payload;
      })
      .addCase(GetHistorychangeOther.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(GetHistory.pending, (state) => {
        state.loading = true;
      })
      .addCase(GetHistory.fulfilled, (state, action) => {
        state.loading = false;
        state.history = action.payload;
      })
      .addCase(GetHistory.rejected, (state, action) => {
        state.loading = false;
      });
  },
});

export const { resetHistoryChange } = historyChange.actions;

export default historyChange.reducer;
